/**
 * User role constants - Single source of truth for user roles
 * Using const object pattern for type safety and runtime validation
 */
export const USER_ROLE = {
  User: 'User',
  Counsellor: 'Counsellor',
  Admin: 'Admin',
  ContentCreator: 'ContentCreator',
} as const;

/**
 * Type derived from USER_ROLE values
 * Usage: roles: UserRole[]
 */
export type UserRole = (typeof USER_ROLE)[keyof typeof USER_ROLE];

/**
 * Array of all valid user role values
 * Usage: @IsEnum(USER_ROLE_VALUES) or enum: USER_ROLE_VALUES
 */
export const USER_ROLE_VALUES = Object.values(USER_ROLE);
